import React, { useEffect, useState, useRef } from "react";
import { withSnackbar } from "notistack";
import { IconButton } from "@mui/material";
import { Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";

import { ApiMasters } from "apihandlers//masters/masters";

import { DateFunctions } from "common/datefunctions";
import {
  NOTIFY,
  FORMATS,
  CONFIG,
  API_CONFIG,
  DEFAULTS,
  GOPAL_SNACKS,
} from "common/config";
import { COLORS } from "common/colors";
import { ERRORS, LABELS, SUCCESS, WARNINGS } from "common/labels";
import { COMMON_JS } from "common/scripts";
import { ApiIndents } from "apihandlers/indent";

const thumbnailImg = require("assets/images/pdf.png");

const ApiMastersHandler = new ApiMasters();
const ApiIndentsHandler = new ApiIndents();

const FuelForm = (props: any) => {
  const {
    defaultValues,
    setManageDialog,
    selectedRow,
    setSelectedRow,
    reloadGrid,
  } = props;

  const tripsTypeRef: any = useRef();
  const driverTypeRef: any = useRef();
  const categoryTypeRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [trips, setTrips] = useState<any>([]);
  const [drivers, setDrivers] = useState<any>([]);
  const [category, setCategory] = useState<any>([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [indentGroup, setIndentGroup] = useState<any>([]);
  const [uploading, setUploading] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any>({});
  const [fuelFiles, setFuelFiles] = useState<any>([]);
  const [selectedDriver, setSelectedDriver] = useState<any>(
    selectedRow.id
      ? {
          id: selectedRow.driverId,
          label: selectedRow.driverName,
        }
      : {}
  );

  useEffect(() => {
    if (loading) {
      getTrips();
      if (selectedRow.id) {
        getUploadedFiles(selectedRow.id);
      }
    }
  }, [loading]);

  const getTrips = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      fromDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
      toDate: DateFunctions.getDate("thismonth", "to", FORMATS.SQL_DATE),
      activeStatus: "true",
      minResponse: true,
    };
    ApiIndentsHandler.getTripsList(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.indentNo,
            data: r,
          };
        });
        setIndentGroup(list);
        setTrips(list);
        getDrivers();
      }
    });
  };

  const getDrivers = () => {
    const args = {
      activeStatus: "true",
      shortMode: true,
    };
    ApiMastersHandler.getDrivers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setDrivers(list);
        getCharges();
      }
    });
  };

  const getCharges = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getCharges(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setCategory(list);
      }
    });
  };

  const onSave = () => {
    const indentId = tripsTypeRef.current.selectedValue.id;
    const paymentDate = (
      document.getElementById("transactionDate") as HTMLInputElement
    ).value.trim();
    const driverId = driverTypeRef.current.selectedValue.id;
    const chargedId = categoryTypeRef.current.selectedValue.id;
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();
    const amount = parseInt(
      (document.getElementById("amount") as HTMLInputElement).value.trim()
    );
    const fuelQty = parseInt(
      (document.getElementById("fuelQty") as HTMLInputElement).value.trim()
    );
    const refNo = (
      document.getElementById("referenceNumber") as HTMLInputElement
    ).value.trim();
    let op = document.querySelector(
      'input[name="transactionMode"]:checked'
    ) as HTMLInputElement;
    const paymentMode = op ? op.value : "";
    op = document.querySelector(
      'input[name="transactionModeOfGopal"]:checked'
    ) as HTMLInputElement;
    const paymentModeOfGopal = op ? op.value : "";
    op = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = op ? op.value : "";

    // Validations
    let errors = [];
    if (!indentId) {
      errors.push({
        id: "indentId",
        msg:
          "<span class='bold'>" +
          LABELS.TRIP +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (paymentDate == "") {
      errors.push({
        id: "paymentDate",
        msg:
          "<span class='bold'>" +
          LABELS.TRANSACTION_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!driverId) {
      errors.push({
        id: "driverId",
        msg:
          "<span class='bold'>" +
          LABELS.DRIVERS_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!chargedId) {
      errors.push({
        id: "chargedId",
        msg:
          "<span class='bold'>" +
          LABELS.CATEGORY +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!amount) {
      errors.push({
        id: "amount",
        msg:
          "<span class='bold'>" +
          LABELS.AMMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!fuelQty) {
      errors.push({
        id: "fuelQty",
        msg:
          "<span class='bold'>" +
          LABELS.FUEL_QUANTITY +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!GOPAL_SNACKS) {
      if (!paymentMode) {
        errors.push({
          id: "paymentMode",
          msg:
            "<span class='bold'>" +
            LABELS.TRANSACTION_MODE +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
    }
    if (GOPAL_SNACKS) {
      if (!paymentModeOfGopal) {
        errors.push({
          id: "paymentModeOfGopal",
          msg:
            "<span class='bold'>" +
            LABELS.TRANSACTION_MODE_OF_GOPAL +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      id: selectedRow.id || -1,
      indentId,
      paymentDate,
      amount,
      remarks,
      chargedId,
      driverId,
      fuelQty,
      refNo,
      paymentMode: GOPAL_SNACKS ? paymentModeOfGopal : paymentMode,
      isPayment: "true",
      activeStatus,
      files: fuelFiles,
    };
    setIsSubmit(true);
    ApiIndentsHandler.manageIndentPayments(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      // setFuelFiles(null);
      setUploading(true);
      uploadFile(file, base64).then((res) => {
        // setFuelFiles([res]);
        setUploading(false);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "fuel",
    };
    let fileInfo = null;
    try {
      const res = await ApiIndentsHandler.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        setFuelFiles([...fuelFiles, fileInfo]);
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };

  const handleTripChange = (e, f) => {
    const trip = indentGroup.find((r) => r.id === f.data.id);
    if (trip) {
      setSelectedDriver(null);
      setTimeout(() => {
        setSelectedDriver({
          id: trip.data.driverId,
          label: trip.data.driverName,
        });
      }, 150);
    } else {
      setSelectedDriver(null);
      setTimeout(() => {
        setSelectedDriver({});
      }, 150);
    }
  };

  const getUploadedFiles = (ledgerId: any) => {
    const args = {
      ledgerId,
    };
    setUploading(true);
    setFuelFiles([]);
    ApiIndentsHandler.getIndentLedgerFileInfo(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        setFuelFiles(list);
        setUploading(false);
      }
    });
  };

  console.log("trips:", trips);

  return (
    <UiDialog
      title={
        defaultValues.id
          ? "Add New " + LABELS.FUEL + " : " + defaultValues.indentGroup
          : selectedRow.id
          ? "Edit  " + LABELS.FUEL + " : " + selectedRow.indentGroup
          : "Add New " + LABELS.FUEL
      }
      open={true}
      size={"sm"}
      onClose={() => {
        setSelectedRow({});
        setManageDialog(false);
      }}
    >
      <div className="flexColumn">
        <div className="formGroup red">
          <label>
            {LABELS.TRIP}
            {<span>{" *"}</span>}
          </label>
          <AutoComplete
            list={trips}
            childRef={tripsTypeRef}
            defaultValue={
              defaultValues.indentId
                ? {
                    id: defaultValues.indentId,
                    label: defaultValues.indentGroup,
                  }
                : selectedRow.id
                ? {
                    id: selectedRow.indentId,
                    label: selectedRow.indentGroup,
                  }
                : null
            }
            onChange={handleTripChange}
            disabled={defaultValues.indentId || isSubmit}
          />
        </div>
        <div className="formGroup red">
          <TxtRow
            id={"transactionDate"}
            label={LABELS.TRANSACTION_DATE}
            defaultValue={
              selectedRow.paymentDateUnformatted
                ? DateFunctions.getFormatedDate(
                    selectedRow.paymentDateUnformatted,
                    FORMATS.SQL_DATE,
                    FORMATS.SQL_DATE
                  )
                : DateFunctions.getDate("now", "from", FORMATS.SQL_DATE)
            }
            required={true}
            type={"datetime-local"}
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup red">
          <label>
            {LABELS.DRIVERS_NAME}
            {<span>{" *"}</span>}
          </label>
          {selectedDriver && (
            <AutoComplete
              list={drivers}
              childRef={driverTypeRef}
              defaultValue={
                defaultValues.driverId
                  ? {
                      id: defaultValues.driverId,
                      label: defaultValues.driverName,
                    }
                  : selectedDriver.id
                  ? selectedDriver
                  : null
              }
              disabled={defaultValues.driverId || isSubmit}
            />
          )}
        </div>
        <div className="formGroup red">
          <label>
            {LABELS.CATEGORY}
            {<span>{" *"}</span>}
          </label>
          <AutoComplete
            list={category}
            childRef={categoryTypeRef}
            defaultValue={
              selectedRow.chargedId
                ? {
                    id: selectedRow.chargedId,
                    label: selectedRow.chargesName,
                  }
                : null
            }
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup">
          <TxtRow
            id={"remarks"}
            label={LABELS.REMARKS}
            defaultValue={selectedRow.remarks}
            disabled={isSubmit}
          />
        </div>
        <div className="flexColumn">
          <div className="flexRowJustify">
            <div className="formGroup width45 red">
              <TxtRow
                id={"amount"}
                label={LABELS.AMMOUNT}
                defaultValue={
                  selectedRow.id
                    ? Number(selectedRow.amount).toString()
                    : selectedRow.amount
                }
                disabled={isSubmit}
                type={"number"}
                required={true}
              />
            </div>
            <div className="formGroup width45 red">
              <TxtRow
                id={"fuelQty"}
                label={LABELS.FUEL_QUANTITY}
                defaultValue={
                  selectedRow.id
                    ? Number(selectedRow.fuelQty).toString()
                    : selectedRow.fuelQty
                }
                disabled={isSubmit}
                required={true}
                type={"number"}
              />
            </div>
          </div>
        </div>
        <div className="formGroup">
          <TxtRow
            id={"referenceNumber"}
            label={LABELS.REFERENCE_NUMBER}
            defaultValue={selectedRow.refNo}
            disabled={isSubmit}
          />
        </div>

        {GOPAL_SNACKS ? (
          <div className="formGroup red">
            <label>
              {LABELS.TRANSACTION_MODE_OF_GOPAL}
              {<span>{" *"}</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "0",
                  label: LABELS.RAJKOT,
                  value: LABELS.RAJKOT,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "RAJKOT"
                    : true,
                  disabled: false,
                },
                {
                  id: "1",
                  label: LABELS.MODASA,
                  value: LABELS.MODASA,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "MODASA"
                    : false,
                  disabled: false,
                },
                {
                  id: "2",
                  label: LABELS.NAGPUR,
                  value: LABELS.NAGPUR,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "NAGPUR"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"transactionModeOfGopal"}
              disabled={isSubmit}
            />
          </div>
        ) : (
          <div className="formGroup red">
            <label>
              {LABELS.TRANSACTION_MODE}
              {<span>{" *"}</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "0",
                  label: LABELS.CASH,
                  value: LABELS.CASH,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "CASH"
                    : true,
                  disabled: false,
                },
                {
                  id: "1",
                  label: LABELS.BANK,
                  value: LABELS.BANK,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "BANK"
                    : false,
                  disabled: false,
                },
                {
                  id: "2",
                  label: LABELS.UPI,
                  value: LABELS.UPI,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "UPI"
                    : false,
                  disabled: false,
                },
                {
                  id: "3",
                  label: LABELS.CARD,
                  value: LABELS.CARD,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "CARD"
                    : false,
                  disabled: false,
                },
                {
                  id: "4",
                  label: LABELS.NONE,
                  value: LABELS.NONE,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "NONE"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"transactionMode"}
              disabled={isSubmit}
            />
          </div>
        )}

        <div className="formGroup">
          <label>{LABELS.ACTIVE_STATUS}</label>
          <RadioBtn
            list={[
              {
                id: "0",
                label: LABELS.ACTIVE,
                value: "Yes",
                checked: selectedRow.id
                  ? selectedRow.activeStatus === "Yes"
                  : true,
                disabled: false,
              },
              {
                id: "1",
                label: LABELS.INACTIVE,
                value: "No",
                checked: selectedRow.id
                  ? selectedRow.activeStatus === "No"
                  : false,
                disabled: false,
              },
            ]}
            row={true}
            name={"activeStatus"}
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup">
          <label>
            {LABELS.FILE_UPLOAD}
            <small>
              {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
            </small>
          </label>
          <TxtBox
            type={"file"}
            id="uploadFile"
            // defaultValue={selectedRow.id ? selectedRow.fuelFiles : null}
            className="uploadFile"
            accept="image/*,.pdf"
            onChange={onUploadFile}
          />
          <div
            className="formGroup"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {fuelFiles.map((u, i) => {
              return (
                <div className="thumbnailBox width20">
                  <IconButton
                    className="thumbnailBoxIcon"
                    onClick={() => {
                      const list = fuelFiles.filter((a, j) => j !== i);
                      setFuelFiles(list);
                    }}
                  >
                    <IconClose />
                  </IconButton>
                  <img
                    onClick={() =>
                      window.open(API_CONFIG.STATIC_URL + u.path, "_blank")
                    }
                    src={
                      u.mimeType === "pdf"
                        ? thumbnailImg
                        : API_CONFIG.STATIC_URL + u.path
                    }
                    className="responsive cursor"
                  />
                </div>
              );
            })}
            {uploading && (
              <div className="thumbnailBox width20">
                <SkeletonBox height={300} />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="formGroup submitBtnWrapper">
        <div className="flexbtnjustify">
          <Btn
            text={LABELS.CANCEL}
            bgColor={COLORS.RELOAD_EXPORT}
            color={COLORS.RELOAD_EXPORT_TEXT}
            onClick={() => {
              setSelectedRow({});
              setManageDialog(false);
            }}
          />
          <Btn
            text={LABELS.SAVE}
            onClick={onSave}
            loading={isSubmit}
            bgColor={COLORS.SAVE_GREEN}
          />
        </div>
      </div>
    </UiDialog>
  );
};

export default withSnackbar(FuelForm);
